/**
 * Converts a File to a Blob by reading it into an ArrayBuffer first.
 * Works around iOS WKWebView bug where File objects from <input type="file">
 * can have broken binary data references.
 */
export async function prepareFileForUpload(file) {
  try {
    const arrayBuffer = await file.arrayBuffer();
    return new Blob([arrayBuffer], { type: file.type });
  } catch (e) {
    console.warn('prepareFileForUpload fallback: returning original file', e);
    return file;
  }
}
